<template>
    <nav
        class="
            bg-white
            rounded-lg
            p-4
            flex
            gap-8
            flex-col
            lg:flex-row
            items-center
            my-6
            text-gray-500
        "
    >
        <new-select-option
            name="activity"
            prefix="Activity:"
            @update:modelValue="changeActivity"
            :model-value="state.activity"
            :options="activityFilter"
        ></new-select-option>

        <new-select-option
            name="userId"
            prefix="Member:"
            @update:modelValue="changeMember"
            :model-value="state.userId"
            :options="memberFilter"
        ></new-select-option>

        <new-select-option
            name="playbookId"
            prefix="Playbook:"
            @update:modelValue="changePlaybook"
            :model-value="state.playbookId"
            :options="playbookFilter"
        ></new-select-option>
        <div class="flex gap-2 items-center">
            <VueDatePicker
                v-model="state.date"
                range
                @update:modelValue="changeDate"
            ></VueDatePicker>
        </div>
    </nav>

    <div class="bg-white rounded-lg p-4 flex flex-col gap-2 my-6 text-gray-500">
        <div class="flex justify-center py-6" v-if="state.isLoading">
            <LoadingCircle></LoadingCircle>
        </div>
        <div class="flex" v-for="item in state.data" :key="item.id" v-else>
            <AuditCreatePlay
                v-if="item.activity == 'create-play'"
                :data="item"
            ></AuditCreatePlay>
            <AuditViewPlay
                v-else-if="item.activity == 'view-play'"
                :data="item"
            ></AuditViewPlay>
            <AuditEditPlay
                v-else-if="item.activity == 'edit-play'"
                :data="item"
            ></AuditEditPlay>
            <AuditRenamePlay
                v-else-if="item.activity == 'rename-play'"
                :data="item"
            ></AuditRenamePlay>
            <AuditPlayVideo
                v-else-if="item.activity == 'play-video'"
                :data="item"
            ></AuditPlayVideo>
        </div>

        <div
            v-if="!state.isLoading && state.data.length == 0"
            class="flex justify-center py-6"
        >
            No activity found
        </div>
    </div>
</template>

<script setup>
import { computed, reactive, onMounted, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const state = reactive({
    data: [],
    members: [],
    playbooks: [],
    date: null,

    activity: null,
    userId: null,
    playbookId: null,
    isLoading: false,
});

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");

function changeActivity(value) {
    state.activity = value;
    refreshData();
}

function changeMember(value) {
    state.userId = value;
    refreshData();
}

function changePlaybook(value) {
    state.playbookId = value;
    refreshData();
}

function changeDate() {
    refreshData();
}

const activityFilter = [
    { value: null, label: "All" },
    { value: "create-play", label: "Create Play" },
    { value: "view-play", label: "Open Play" },
    { value: "edit-play", label: "Edit Play" },
    { value: "rename-play", label: "Rename Play" },
    { value: "play-video", label: "Play Video" },
];

const memberFilter = computed(() => {
    const data = state.members
        .filter((member) => member.user)
        .map((member) => {
            return {
                value: member.user.id,
                label: member.user.name,
            };
        });

    return [{ value: null, label: "All" }, ...data];
});

const playbookFilter = computed(() => {
    const data = state.playbooks.map((playbook) => {
        return {
            value: playbook.playbook_id,
            label: playbook.playbook_title,
        };
    });

    return [{ value: null, label: "All" }, ...data];
});

async function refreshData() {
    state.isLoading = true;
    try {
        const resp = await axios.get("/audits/list", {
            params: {
                activity: state.activity,
                playbookId: state.playbookId,
                userId: state.userId,
                teamId: teamIdFromUrl,
                startDate: state.date ? state.date[0] : null,
                endDate: state.date ? state.date[1] : null,
            },
        });
        state.data = resp.data;
    } catch (e) {}

    state.isLoading = false;
}

async function getPlaybooks() {
    const resp = await axios.get("/playbook/list", {
        params: {
            teamId: teamIdFromUrl,
        },
    });
    state.playbooks = resp.data;
}

async function getMembers() {
    const resp = await axios.get("/teams/membersApi", {
        params: {
            teamId: teamIdFromUrl,
        },
    });
    state.members = resp.data;
}

onMounted(() => {
    refreshData();
    getMembers();
    getPlaybooks();
});
</script>
